module.exports = __webpack_public_path__ + "img/mon_256.5ae45630.png";